import { createSelector } from '@ngrx/store';

import { onlineOrderState } from '../root';

export const isVoucherFailed = createSelector(onlineOrderState, (onlineOrder) => onlineOrder.voucherRequest.hasFailed);
